import styled from 'styled-components';

import { Flex, Icons, Typography } from 'components';
import { useOffers } from 'features/offers';

import { ReactComponent as LogoPixImg } from 'app/images/logo-pix.svg';
import { PaymentsMethod } from 'features/offers/types';

const MethodButtonWrapper = styled(Flex)`
  /* overflow: scroll;

  scrollbar-width: thin;
  scrollbar-color: blue orange; */

  /* Works on Chrome, Edge, and Safari */
  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.gray_300};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.gray_600};
    border: 2px solid ${({ theme }) => theme.colors.gray_300};
    border-radius: 10px;
  }
`;

const MethodButton = styled('button').attrs({
  type: 'button',
})`
  width: 100px;
  height: 80px;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: left;
  padding: 10px;
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.gray_300};
  border-radius: 4px;
  cursor: pointer;

  margin: 0 5px;

  &:first-child {
    margin-left: 0;
  }

  background: ${(props: any) => (props['data-active'] ? props.theme.colors.gray_100 : 'white')};
  opacity: ${(props: any) => (props.disabled ? 0.5 : 1)};

  &:hover {
    background: ${({ theme, disabled }) => (!disabled ? theme.colors.gray_100 : theme.colors.white)};
  }
`;

const MethodIcon = styled(Icons)`
  width: 23px;
  color: ${({ theme }) => theme.colors.primary_400};
`;

const LogoPix = styled(LogoPixImg)`
  width: 70px;
`;

interface PaymentMethodsProps {
  paymentMethod: PaymentsMethod;
  isInternational: boolean;
  onChange: (paymentMethod: PaymentsMethod, installments: number, value: number) => void;
}

const PaymentMethods = ({ paymentMethod, onChange, isInternational }: PaymentMethodsProps) => {
  const { buyInformation } = useOffers();

  const handleOnChange = (receivedPaymentMethod: PaymentsMethod) => {
    let installments = 1;
    let value = 0;

    if (receivedPaymentMethod === 'creditCard') {
      const methodInformation = buyInformation.creditCardValues[buyInformation.creditCardValues.length - 1];

      installments = methodInformation.installments;
      value = methodInformation.totalValue;
    } else if (receivedPaymentMethod === 'boleto') {
      const methodInformation = buyInformation.boletoValues[0];

      installments = methodInformation.installments;
      value = methodInformation.totalValue;
    } else if (receivedPaymentMethod === 'pix') {
      const methodInformation = buyInformation.pixValues[0];

      installments = methodInformation.installments;
      value = methodInformation.totalValue;
    }

    onChange(receivedPaymentMethod, installments, value);
  };

  if (buyInformation.freeOffer) {
    return <></>;
  } else {
    return (
      <Flex flexGrow={0} flexDirection="column">
        <Typography type="type1" fontWeight="bold">
          Selecione a forma de pagamento:
        </Typography>

        <MethodButtonWrapper maxWidth="100%" mt={2} height={80} flexWrap="nowrap">
          {!!buyInformation?.creditCardValues?.length && (
            <MethodButton data-active={paymentMethod === 'creditCard'} onClick={() => handleOnChange('creditCard')}>
              <MethodIcon icon="creditCard" />

              <Typography type="type0" fontWeight="bold">
                Cartão de Crédito
              </Typography>
            </MethodButton>
          )}

          {!!buyInformation?.boletoValues?.length && (
            <MethodButton data-active={paymentMethod === 'boleto'} disabled={isInternational} onClick={() => handleOnChange('boleto')}>
              <MethodIcon icon="barcode" />

              <Typography type="type0" fontWeight="bold">
                Boleto Bancário
              </Typography>
            </MethodButton>
          )}

          {!!buyInformation?.pixValues?.length && (
            <MethodButton data-active={paymentMethod === 'pix'} disabled={isInternational} onClick={() => handleOnChange('pix')}>
              <LogoPix />

              <Typography type="type0" fontWeight="bold">
                Pix
              </Typography>
            </MethodButton>
          )}
        </MethodButtonWrapper>
      </Flex>
    );
  }
};

export default PaymentMethods;
